const container = document.querySelector(".rttsml-slides");
if (container && container instanceof HTMLDivElement) {
	import("./front/index").then(({ mountTestimonials }) => {
		mountTestimonials(container);
	});
}
